import { useLocation, useNavigate } from "react-router-dom";
import { React, useEffect, useState, useRef } from 'react';
import { useSnackbar } from 'notistack';

// material
import { Typography, Button, Box, Stack, Tooltip, TextField, ToggleButtonGroup, ToggleButton, Card, FormControl, IconButton, Autocomplete, Modal, FormLabel, Checkbox } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';

import { styled } from '@mui/material/styles';
import XLSX from 'sheetjs-style';
import Moment from 'moment';
import * as FileSaver from 'file-saver';
import PeopleOutlineRoundedIcon from '@mui/icons-material/PeopleOutlineRounded';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
// components
import AddIcon from "@mui/icons-material/Add";
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { Icon } from '@iconify/react';
import Iconify from '../../Iconify';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from "@mui/icons-material/Edit";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import LoadingProgressBar from '../../../theme/overrides/LoadingProgressBar';
import AppCache from '../../../services/AppCache';
import URLS from '../../../services/urls.service';
import Page from "../../Page";
import StickyHeader from "../../Common/StickyHeader";
import ServiceCards from '../../Common/ServiceCard'

// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));
const stripHtml = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const text = tempDiv.textContent || tempDiv.innerText || "";
    return text.replace(/\s+/g, ' ').trim(); // collapse whitespace and remove line breaks
};

export default function ProjectTeamManagement() {

    const teamColumn = [
        { field: 'ClientId', headerName: 'Client Id', flex: 1 },
        { field: 'ClientName', headerName: 'Client Name', flex: 1.5 },
        { field: 'ClientAlice', headerName: 'Client Alice', flex: 1.5 },
        { field: 'ProjectTeamName', headerName: 'Project Team Name', flex: 1.5 },
        { field: 'Project', headerName: 'Project', flex: 1 },
        { field: 'FromDate', headerName: 'From Date', flex: 0.8 },
        { field: 'ToDate', headerName: 'To Date', flex: 0.8 },
        { field: 'Members', headerName: 'Members', flex: 0.7 },
        { field: 'Status', headerName: 'Status', flex: 1 },
        {
            field: 'actions',
            headerName: 'Action',
            type: 'actions',
            flex: 0.5,
            renderCell: (cellValues, oaDetailsData) => (
                <div>
                    <IconButton
                        onClick={(event) => {
                            handleTeamClick(event, cellValues, oaDetailsData);
                        }}
                    >
                        <Iconify
                            icon="ic:outline-edit"
                            width="20px"
                            height="20px"
                            color="primary.main"
                        />
                    </IconButton>
                </div>
            ),
        },
    ];

    const teamMemberColumn = [
        { field: 'ClientId', headerName: 'Client Id', flex: 1 },
        { field: 'ClientName', headerName: 'Client Name', flex: 1.5 },
        { field: 'ClientAlice', headerName: 'Client Alice', flex: 1.5 },
        { field: 'ProjectTeamName', headerName: 'Project Team Name', flex: 1.5 },
        { field: 'ExecutiveId', headerName: 'Executive ID', flex: 0.5 },
        { field: 'ExecutiveName', headerName: 'Executive Name', flex: 1 },
        { field: 'EmployeeCode', headerName: 'Employee Code', flex: 1 },
        { field: 'Department', headerName: 'Department', flex: 1 },
        { field: 'FromDate', headerName: 'From Date', flex: 1 },
        { field: 'ToDate', headerName: 'To Date', flex: 1 },
        { field: 'NoOfDays', headerName: 'No Of Days', flex: 0.5 },
        { field: 'IsCoordinator ', headerName: 'Is Coordinator', flex: 1 },
        { field: 'Status', headerName: 'Status', flex: 1 },
        {
            field: 'actions',
            headerName: '',
            type: 'actions',
            flex: 0.5,
            renderCell: (cellValues, oaDetailsData) => (
                <div>
                    <IconButton
                        onClick={(event) => {
                            handleTeamMemberClick(event, cellValues, oaDetailsData);
                        }}
                    >
                        <Iconify
                            icon="ic:outline-edit"
                            width="20px"
                            height="20px"
                            color="primary.main"
                        />
                    </IconButton>
                </div>
            ),
        },

    ];

    const navigate = useNavigate();
    const location = useLocation();
    const { enqueueSnackbar } = useSnackbar();
    const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();
    const userId = CurrentLoggedInUser.ExecutiveId;
    const userClientId = CurrentLoggedInUser?.UserClientId;

    const [isLoading, setIsLoading] = useState();
    const [tab, setTab] = useState("teams");
    const [newTeamOpenModal, setNewTeamOpenModal] = useState(false);
    const [teamName, setTeamName] = useState('');
    const [clientTeam, setClientTeam] = useState("");
    const [selectedClientTeam, setSelectedClientTeam] = useState([]);
    const [projectTeam, setProjectTeam] = useState("");
    const [selectedProjectTeam, setSelectedProjectTeam] = useState([]);
    const [executiveTeam, setExecutiveTeam] = useState('');
    const [selectedExecutiveTeam, setSelectedExecutiveTeam] = useState([]);
    const [selectedMembers, setSelectedMembers] = useState([]);

    const [client, setClient] = useState("");
    const [selectedClient, setSelectedClient] = useState([]);
    const [project, setProject] = useState('');
    const [selectedProject, setSelectedProject] = useState([]);
    const [executive, setExecutive] = useState('');
    const [selectedExecutive, setSelectedExecutive] = useState([]);
    const [team, setTeam] = useState("");
    const [selectedTeam, setSelectedTeam] = useState([]);
    const [effectiveFromValue, setEffectiveFromValue] = useState(null);
    const [effectiveToValue, setEffectiveToValue] = useState(null);
    const [showInactive, setShowInactive] = useState(false);
    const [teamData, setTeamData] = useState([]);
    const [teamMemberData, setTeamMemberData] = useState([]);
    const [pageSize, setPageSize] = useState(25);
    const [pageSize1, setPageSize1] = useState(25);

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: executiveTeam.length > 0 ? '90%' : '40%',
        bgcolor: 'background.paper',
        boxShadow: 24,
        maxHeight: '70vh',
        overflow: 'auto',
        borderRadius: '8px',
    };

    useEffect(() => {
        URLS.getServiceEntryClientName()
            .then((response) => {
                setSelectedClient(Array.isArray(response.data) ? response.data : []);
                setSelectedClientTeam(Array.isArray(response.data) ? response.data : []);

            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });

        URLS.getServiceEntryProject()

            .then((response) => {
                setSelectedProject(Array.isArray(response.data) ? response.data : []);
                setSelectedProjectTeam(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.loadExecutives(userClientId)
            .then((response) => {
                setSelectedExecutive(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        const payloadExecutive = { ExecutiveLoginId: 0 };
        URLS.getExecutiveInfo(payloadExecutive)
            .then((response) => {
                setSelectedExecutiveTeam(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log("Error");
            });
    }, []);

    const handleTeamName = (event) => {
        setTeamName(event.target.value);
    }
    const handleNewTeamOpenModal = () => {
        setNewTeamOpenModal(true);
    }
    const handleNewTeamCloseModal = () => {
        setNewTeamOpenModal(false);
    }
    const handleClientTeam = (newValue) => {
        setClientTeam(newValue?.ClientId || "");
    };
    const handleProjectTeam = (newValue) => {
        setProjectTeam(newValue?.ProjectVersionId || "");
    };
    const handleExecutiveTeam = (newValue) => {
        const executive = newValue.map((item) => item.Id);
        setExecutiveTeam(executive);
        setSelectedMembers(newValue);
    };
    const handleClient = (newValue) => {
        setClient(newValue?.ClientId || "");
    };
    const handleProject = (newValue) => {
        setProject(newValue?.ProjectVersionId || "");
    };
    const handleTeam = (newValue) => {
        setTeam(newValue?.SiteId || "");
    };

    const handlExecutive = (newValue) => {
        setExecutive(newValue?.Id || "");
    };
    const handleEffFrom = (newValue) => {
        setEffectiveFromValue(newValue);

    };
    const handleEffTo = (newValue) => {
        setEffectiveToValue(newValue);
    };
    const handleTabChange = (event, newView) => {
        if (newView !== null) {
            setTab(newView);
        }
    };
    const handleInactiveToggle = () => {
        setShowInactive((prev) => !prev);
    };
    const handleReset = () => {
        setClient("");
        setEffectiveFromValue(null);
        setEffectiveToValue(null);
    };

    const handleTeamClick = (event, rowData) => {
        console.log("rowData", rowData, rowData?.ServiceId)
        URLS.editLoadServiceData({ ServiceId: rowData?.ServiceId })
            .then((response) => {
                const apiData = Array.isArray(response.data)
                    ? response.data[0]   //  object
                    : response.data;


                navigate("/dashboard/servicedetailspage", {
                    state: {
                        loadData: apiData, // object
                        openServiceTab: true,
                        fromEdit: true,
                    },
                });
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });

        console.log("************************", rowData);
    };
    const handleTeamMemberClick = (event, rowData) => {
        console.log("rowData", rowData, rowData?.ServiceId)
        URLS.editLoadServiceData({ ServiceId: rowData?.ServiceId })
            .then((response) => {
                const apiData = Array.isArray(response.data)
                    ? response.data[0]   //  object
                    : response.data;


                navigate("/dashboard/servicedetailspage", {
                    state: {
                        loadData: apiData, // object
                        openServiceTab: true,
                        fromEdit: true,
                    },
                });
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });

        console.log("************************", rowData);
    };

    const exportToExcel = () => {
        const fileExtension = ".xlsx";
        const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

        // Columns to exclude
        const excludeColumns = [
            "executiveId",
            "ClientId",
            "SiteId",
            "IssueOwnedById",
            "ReportingToId",
            "SubstatusId",
            "ProjectVersionId",
            "executiveId",
            "ProjectId",
            "LastAllocatedById",
            "IssueCategoryId",
            "ActivityId",
            "ContactPersonId",
            "ExecutiveId",
            "ServiceTypeId",

        ];

        // Check if reports are available
        if (!filteredServiceData || filteredServiceData.length === 0) {
            enqueueSnackbar("No data available to export.", { variant: "error" });
            return;
        }

        // Prepare headers excluding unwanted columns
        const headers = Object.keys(filteredServiceData[0]).filter(
            (key) => !excludeColumns.includes(key)
        );
        // Prepare the row data based on reports data
        const dataToExport = filteredServiceData.map((row) =>
            headers.map((header) => {
                const cellValue = row[header];
                // Apply stripHtml if the value is a string
                return typeof cellValue === "string" ? stripHtml(cellValue) : cellValue;
            })
        );

        const dataWithHeaders = [headers, ...dataToExport]; // Combine headers with data rows
        const ws = XLSX.utils.aoa_to_sheet(dataWithHeaders); // Convert to AOA format
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] }; // Create workbook
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" }); // Write workbook to buffer
        const data = new Blob([excelBuffer], { type: fileType }); // Create a blob from the buffer

        const timestamp = Moment().format("DD-MMM-YYYY_HH-mm-ss");
        const fileName = `EditServiceListing_${timestamp}${fileExtension}`; // Add dynamic name

        FileSaver.saveAs(data, fileName); // Save the file
        enqueueSnackbar("Exported Excel successfully.", { variant: "success" });
    };

    const onFilterClick = () => {
        setIsLoading(true);
        const payload = {
            "IssueId": Number(issueId) || 0,
            "UserId": userId || 0,
            "ClientId": client || 0,
            "SiteId": site || 0,
            "ContactPersonId": executive || 0,
            "FromDate": effectiveFromValue ? Moment(effectiveFromValue).format("DD/MMM/YYYY") : "",
            "ToDate": effectiveToValue ? Moment(effectiveToValue).format("DD/MMM/YYYY") : ""
        }
        console.log("filter payload", payload)
        URLS.editLoadServiceFilter(payload)
            .then((response) => {
                if (Array.isArray(response.data)) {
                    setTeamData(response.data);
                    setIsLoading(false);
                }
            })
            .catch(error => {
                setTeamData([]);
                enqueueSnackbar("Data not found", { variant: 'error' });
                setIsLoading(false);

            });
    };

    useEffect(() => {
        handleReset();
    }, [location.key]);

    const teamRows = [
        {
            id: 1,
            ClientId: "C001",
            ClientName: "ABC Corporation",
            ClientAlice: "Alice Johnson",
            ProjectTeamName: "Alpha Team",
            Project: "CRM Implementation",
            FromDate: "01-01-2026",
            ToDate: "30-06-2026",
            Members: "John, Priya, Rahul",
            Status: "Active",
        },
        {
            id: 2,
            ClientId: "C002",
            ClientName: "XYZ Technologies",
            ClientAlice: "Michael Smith",
            ProjectTeamName: "Beta Squad",
            Project: "Mobile App Development",
            FromDate: "15-02-2026",
            ToDate: "15-08-2026",
            Members: "Anita, Vikram, Sneha",
            Status: "Active",
        },
        {
            id: 3,
            ClientId: "C003",
            ClientName: "Global Solutions",
            ClientAlice: "Emma Williams",
            ProjectTeamName: "Gamma Group",
            Project: "ERP Upgrade",
            FromDate: "01-03-2025",
            ToDate: "31-12-2025",
            Members: "Arjun, Meena, Karan",
            Status: "Completed",
        },
        {
            id: 4,
            ClientId: "C004",
            ClientName: "TechNova Pvt Ltd",
            ClientAlice: "David Brown",
            ProjectTeamName: "Delta Force",
            Project: "Cloud Migration",
            FromDate: "10-04-2026",
            ToDate: "10-10-2026",
            Members: "Riya, Mohit, Aakash",
            Status: "Pending",
        },
        {
            id: 5,
            ClientId: "C005",
            ClientName: "NextGen Systems",
            ClientAlice: "Sophia Davis",
            ProjectTeamName: "Omega Team",
            Project: "Website Redesign",
            FromDate: "05-01-2026",
            ToDate: "05-05-2026",
            Members: "Neha, Rohit, Simran",
            Status: "Active",
        }
    ];

    const teamMemberRows = [
        {
            id: 1,
            ClientId: "C001",
            ClientName: "ABC Corporation",
            ClientAlice: "Alice Johnson",
            ProjectTeamName: "Alpha Team",
            ExecutiveId: "E101",
            ExecutiveName: "Rahul Sharma",
            EmployeeCode: "EMP001",
            Department: "Development",
            FromDate: "01-01-2026",
            ToDate: "31-01-2026",
            NoOfDays: 31,
            IsCoordinator: "Yes",
            Status: "Active",
        },
        {
            id: 2,
            ClientId: "C001",
            ClientName: "ABC Corporation",
            ClientAlice: "Alice Johnson",
            ProjectTeamName: "Alpha Team",
            ExecutiveId: "E102",
            ExecutiveName: "Priya Mehta",
            EmployeeCode: "EMP002",
            Department: "QA",
            FromDate: "01-01-2026",
            ToDate: "31-01-2026",
            NoOfDays: 31,
            IsCoordinator: "No",
            Status: "Active",
        },
        {
            id: 3,
            ClientId: "C002",
            ClientName: "XYZ Technologies",
            ClientAlice: "Michael Smith",
            ProjectTeamName: "Beta Squad",
            ExecutiveId: "E103",
            ExecutiveName: "Amit Verma",
            EmployeeCode: "EMP003",
            Department: "UI/UX",
            FromDate: "15-02-2026",
            ToDate: "15-03-2026",
            NoOfDays: 29,
            IsCoordinator: "Yes",
            Status: "Completed",
        },
        {
            id: 4,
            ClientId: "C003",
            ClientName: "Global Solutions",
            ClientAlice: "Emma Williams",
            ProjectTeamName: "Gamma Group",
            ExecutiveId: "E104",
            ExecutiveName: "Sneha Patil",
            EmployeeCode: "EMP004",
            Department: "Support",
            FromDate: "01-03-2026",
            ToDate: "20-03-2026",
            NoOfDays: 20,
            IsCoordinator: "No",
            Status: "Pending",
        },
        {
            id: 5,
            ClientId: "C004",
            ClientName: "TechNova Pvt Ltd",
            ClientAlice: "David Brown",
            ProjectTeamName: "Delta Force",
            ExecutiveId: "E105",
            ExecutiveName: "Karan Singh",
            EmployeeCode: "EMP005",
            Department: "DevOps",
            FromDate: "10-04-2026",
            ToDate: "25-04-2026",
            NoOfDays: 16,
            IsCoordinator: "No",
            Status: "Active",
        }
    ];

    return (
        <Page title="Project Team Management | tiketic" >
            <StickyHeader
                title="Project Team Management"
                showButton={false}

                rightContent={
                    <Stack direction="row" spacing={2} alignItems="center" mt={'2px'}>

                        <Button
                            variant="contained"
                            color="secondary"
                            startIcon={<AddIcon />}
                            sx={{
                                whiteSpace: "nowrap",
                                textTransform: "none",
                                mt: "3px",
                                "& .MuiButton-startIcon": { mr: "2px" },

                            }}
                            onClick={handleNewTeamOpenModal}
                        >
                            Create New Team
                        </Button>
                        <Modal open={newTeamOpenModal} onClose={handleNewTeamCloseModal}>
                            <Box sx={{
                                ...modalStyle,
                                display: 'flex',
                                flexDirection: 'column',
                                maxHeight: '70vh',
                                overflow: 'hidden',
                            }}>
                                <Box
                                    sx={{
                                        position: 'sticky',
                                        top: 0,
                                        backgroundColor: '#fff',
                                        zIndex: 1,
                                        borderBottom: '1px solid #E5E5E5',


                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                            padding: '0px 16px',
                                            borderBottom: '1px solid #E0E0E0',
                                            backgroundColor: '#fff',
                                            m: 0, // remove outer margins
                                        }}
                                    >
                                        <Typography variant="h6" color="text.primary" fontWeight="bold">
                                            Create New Team
                                        </Typography>
                                        <IconButton onClick={handleNewTeamCloseModal}>
                                            <CloseIcon />
                                        </IconButton>
                                    </Box>
                                </Box>
                                <Box
                                    sx={{
                                        flex: 1,
                                        pt: 2,
                                        px: 2,
                                    }}
                                >
                                    <Stack direction="row" spacing={3} alignItems="flex-start">
                                        <Box flex={selectedMembers.length > 0 ? 1 : 2}>
                                            <Stack spacing={2}>
                                                <FormControl size="small" fullWidth>
                                                    <FormLabel sx={{
                                                        mb: 0.5,
                                                        '&::after': {
                                                            content: '" *"',
                                                            color: 'red',
                                                        },
                                                    }}
                                                    >
                                                        Team Name
                                                    </FormLabel>
                                                    <TextField fullWidth size="small" value={teamName} onChange={handleTeamName} placeholder="Enter unique team name" />

                                                </FormControl>
                                                <FormControl size="small" fullWidth>
                                                    <FormLabel sx={{
                                                        mb: 0.5,
                                                        '&::after': {
                                                            content: '" *"',
                                                            color: 'red',
                                                        },
                                                    }}
                                                    >
                                                        Client
                                                    </FormLabel>
                                                    <Autocomplete
                                                        fullWidth
                                                        size="small"
                                                        id="clientteam"
                                                        value={selectedClientTeam.find((item) => item.ClientId === clientTeam) || null}
                                                        onChange={(_, newValue) => handleClientTeam(newValue)}
                                                        options={selectedClientTeam}
                                                        getOptionLabel={(option) => option.Name || ""}
                                                        isOptionEqualToValue={(option, value) => option.ClientId === value.ClientId}
                                                        renderOption={(props, option) => (
                                                            <li {...props} key={option.ClientId}>
                                                                {option.Name}
                                                            </li>
                                                        )}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder="Select Client"
                                                                variant="outlined"
                                                            />
                                                        )}

                                                    />
                                                </FormControl>
                                                <FormControl size="small" fullWidth>
                                                    <FormLabel sx={{
                                                        mb: 0.5,
                                                        '&::after': {
                                                            content: '" *"',
                                                            color: 'red',
                                                        },
                                                    }}
                                                    >
                                                        Project
                                                    </FormLabel>

                                                    <Autocomplete
                                                        fullWidth
                                                        size="small"
                                                        id="projectteam"
                                                        value={selectedProjectTeam.find((item) => item.ProjectVersionId === projectTeam) || ""}
                                                        onChange={(_, newValue) => handleProjectTeam(newValue)}
                                                        options={selectedProjectTeam}
                                                        getOptionLabel={(option) => option.ProjectVersionName || ""}
                                                        isOptionEqualToValue={(o, v) => o.ProjectVersionId === v.ProjectVersionId}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder="Select Project"
                                                                variant="outlined"
                                                            />
                                                        )}
                                                        renderOption={(props, option) => (
                                                            <li {...props} key={option.ProjectVersionId}>
                                                                {option.ProjectVersionName}
                                                            </li>
                                                        )}
                                                    />

                                                </FormControl>
                                                <FormControl size="small" fullWidth>
                                                    <FormLabel sx={{
                                                        mb: 0.5,
                                                        '&::after': {
                                                            content: '" *"',
                                                            color: 'red',
                                                        },
                                                    }}
                                                    >
                                                        Add Team Member
                                                    </FormLabel>
                                                    <Autocomplete
                                                        multiple
                                                        fullWidth
                                                        limitTags={2}
                                                        size="small"
                                                        id="executiveteam"
                                                        value={selectedExecutiveTeam.filter((item) => executiveTeam.includes(item.Id))}
                                                        onChange={(_, newValue) => handleExecutiveTeam(newValue)}
                                                        options={selectedExecutiveTeam}
                                                        getOptionLabel={(option) => option.Name || ""}
                                                        isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                                        getOptionSelected={(option, value) => option.Id === value.Id}

                                                        disableClearable

                                                        renderOption={(props, option, { selected }) => (
                                                            <li {...props}>
                                                                <Checkbox checked={selected} />
                                                                {option.Name}
                                                            </li>
                                                        )}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder={
                                                                    executiveTeam.length === 0 ? "Select team member" : ""
                                                                }
                                                            />
                                                        )}
                                                        renderTags={(value, getTagProps) => (
                                                            <div>
                                                                {value.length > 0 && <p>{value.length} selected</p>}
                                                            </div>
                                                        )}
                                                    />

                                                </FormControl>
                                            </Stack>
                                        </Box>
                                        {selectedMembers.length > 0 && (

                                            <Box flex={1}  >
                                                <Box
                                                    sx={{
                                                        borderRadius: "10px",
                                                        backgroundColor: "#FFFFFF",
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        maxHeight: "400px",
                                                        boxShadow: " 0px 0px 2px 0px #00000040",

                                                    }}
                                                >
                                                    {/* Header */}
                                                    <Box sx={{ p: 1 }}>
                                                        <Typography fontSize={12} fontWeight={400}>
                                                            Selected Members ({selectedMembers.length})
                                                        </Typography>
                                                    </Box>

                                                    {/* Scrollable Content */}
                                                    <Box
                                                        sx={{
                                                            px: 2,
                                                            py: 1,
                                                            overflowY: "auto",
                                                        }}
                                                    >
                                                        {selectedMembers.map((member) => (
                                                            <Box
                                                                key={member.Id}
                                                                sx={{
                                                                    display: "flex",
                                                                    justifyContent: "space-between",
                                                                    alignItems: "center",
                                                                    backgroundColor: "#F9FAFB",
                                                                    borderRadius: "10px",

                                                                    mb: 1.5,
                                                                    boxShadow: "0px 0px 1px 0px #00000040"

                                                                }}
                                                            >
                                                                {/* Left Info */}
                                                                <Box>
                                                                    <Typography fontWeight={400}>
                                                                        {member.Name}
                                                                    </Typography>

                                                                    <Box
                                                                        sx={{
                                                                            display: "inline-block",
                                                                            backgroundColor: "#ECEEF2",
                                                                            borderRadius: "6px",
                                                                            px: 1,
                                                                            fontSize: 12,
                                                                            ml: 1,
                                                                        }}
                                                                    >
                                                                        {member.Department}
                                                                    </Box>

                                                                    <Typography
                                                                        variant="body2"
                                                                        color="#374151"
                                                                    >
                                                                        {member.Designation}
                                                                    </Typography>
                                                                </Box>

                                                                {/* Actions */}
                                                                <Box sx={{ display: "flex", gap: 1 }}>
                                                                    <IconButton size="small">
                                                                        <Icon icon="material-symbols:edit-outline-rounded" width="24" height="24" style={{ color: "#374151" }} />
                                                                    </IconButton>

                                                                    <IconButton size="small">
                                                                        <Icon icon="material-symbols:how-to-reg-outline-rounded" width="24" height="24"
                                                                            style={{ color: "#0062FF" }} />
                                                                    </IconButton>

                                                                    <IconButton
                                                                        size="small"
                                                                        color="error"
                                                                        onClick={() =>
                                                                            setSelectedMembers((prev) =>
                                                                                prev.filter((m) => m.Id !== member.Id)
                                                                            )
                                                                        }
                                                                    >
                                                                        <CloseIcon fontSize="small" />
                                                                    </IconButton>
                                                                </Box>
                                                            </Box>
                                                        ))}
                                                    </Box>
                                                </Box>
                                            </Box>
                                        )}

                                    </Stack>

                                </Box>
                                {/* Reset & Save Buttons */}
                                <Box
                                    sx={{
                                        position: 'sticky',
                                        bottom: 0,
                                        backgroundColor: '#fff',
                                        borderTop: "1px solid #D1D5DB",
                                        mt: 1,
                                        p: 1,
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        gap: 2,
                                    }}
                                >

                                    <Button variant="outlined" color="inherit" backgroundColor='#F3F4F6' onClick={{}}>
                                        Reset
                                    </Button>
                                    <Button
                                        size="medium"
                                        type="submit"
                                        variant="contained"
                                        onClick={{}}
                                    >
                                        Create Team
                                    </Button>
                                </Box>

                            </Box>
                        </Modal>
                        <Tooltip title="Export To Excel">
                            <Button
                                variant="outlined"
                                sx={{
                                    whiteSpace: "nowrap",
                                    textTransform: "none",
                                    mt: "3px",
                                    "& .MuiButton-startIcon": { mr: "2px" },
                                    borderColor: "#2e7d32",
                                    color: "#2e7d32",
                                    "& .MuiButton-startIcon": { mr: "2px" },
                                    "&:hover": {
                                        backgroundColor: "#2e7d32",
                                        color: "#FFFFFF",
                                    },
                                    whiteSpace: "nowrap",
                                    textTransform: "none",
                                }}

                                startIcon={<FileUploadOutlinedIcon />}
                            >
                                Export
                            </Button>
                        </Tooltip>
                    </Stack >
                }
            />
            < ContentStyle >

                <Box sx={{
                    display: 'flex', gap: 2, px: 1.5, overflowY: 'hidden'
                }}>
                    <Box sx={{ flex: 1, position: 'relative', display: 'flex' }}>
                        <Card sx={{ borderRadius: '15px', width: "100%", border: '1px solid #E5E5E5', boxShadow: 'none' }}>
                            {/* Header Row */}
                            <Box
                                sx={{
                                    py: 1,
                                    px: 2,

                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        mb: 2,
                                    }}
                                >

                                    {/* Left Side */}
                                    <Box>
                                        <Typography fontSize={16} fontWeight={500}>
                                            Team Overview
                                        </Typography>
                                        <Typography sx={{ color: "#94A3B8", fontSize: "12px" }}>
                                            View and manage all team members
                                        </Typography>
                                    </Box>

                                    {/* Right Side */}
                                    <Box
                                        sx={{
                                            backgroundColor: "#F3F3F5",
                                            borderRadius: "8px",
                                            p: "6px",
                                            display: "inline-flex",
                                        }}
                                    >
                                        <ToggleButtonGroup
                                            value={tab}
                                            exclusive
                                            onChange={handleTabChange}
                                            sx={{
                                                "& .MuiToggleButton-root": {
                                                    border: "none",
                                                    textTransform: "none",
                                                    borderRadius: "12px",
                                                    px: 1,
                                                    py: 0.5,
                                                    color: "#121212",
                                                    backgroundColor: "transparent",

                                                    "&:hover": {
                                                        backgroundColor: "transparent",
                                                    },
                                                },

                                                "& .MuiToggleButton-root.Mui-selected": {
                                                    backgroundColor: "#FFFFFF",
                                                    color: "#121212",
                                                    borderRadius: "8px",

                                                    "&:hover": {
                                                        backgroundColor: "#FFFFFF",
                                                    },
                                                },
                                            }}
                                        >
                                            <ToggleButton
                                                value="teams"
                                                disableRipple
                                            >
                                                <PeopleOutlineRoundedIcon sx={{ fontSize: 20, mr: 1 }} />
                                                Teams
                                            </ToggleButton>

                                            <ToggleButton
                                                value="members"
                                                disableRipple
                                            >
                                                <AccountCircleOutlinedIcon sx={{ fontSize: 20, mr: 1 }} />
                                                Members
                                            </ToggleButton>
                                        </ToggleButtonGroup>
                                    </Box>
                                </Box>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 2,
                                        width: "100%",
                                    }}
                                >
                                    {/* Client */}
                                    <FormControl size="small" sx={{ flex: 1 }}>
                                        <Autocomplete
                                            fullWidth
                                            limitTags={2}
                                            size="small"
                                            id="client"
                                            value={selectedClient.find((option) => option.ClientId === client) || ""}
                                            onChange={(_, newValue) => handleClient(newValue)}
                                            options={selectedClient}

                                            getOptionLabel={(option) => option.Name || ""}
                                            isOptionEqualToValue={(option, value) => option.ClientId === value.ClientId}
                                            renderInput={(params) => (
                                                <TextField {...params} placeholder="All Clients" />
                                            )}
                                            renderOption={(props, option) => (
                                                <li {...props} key={option.ClientId}>
                                                    {option.Name}
                                                </li>
                                            )}
                                        />

                                    </FormControl>

                                    {/* Project */}
                                    <FormControl size="small" sx={{ flex: 1 }}>
                                        <Autocomplete
                                            fullWidth
                                            size="small"
                                            id="project"
                                            value={selectedProject.find((item) => item.ProjectVersionId === project) || ""}
                                            onChange={(_, newValue) => handleProject(newValue)}
                                            options={selectedProject}
                                            getOptionLabel={(option) => option.ProjectVersionName || ""}
                                            isOptionEqualToValue={(o, v) => o.ProjectVersionId === v.ProjectVersionId}
                                            renderInput={(params) => (
                                                <TextField {...params} placeholder="All Projects" />
                                            )}
                                            renderOption={(props, option) => (
                                                <li {...props} key={option.ProjectVersionId}>
                                                    {option.ProjectVersionName}
                                                </li>
                                            )}
                                        />

                                    </FormControl>

                                    {/* Team (Second Dropdown) */}
                                    <FormControl size="small" sx={{ flex: 1 }}>
                                        <Autocomplete
                                            fullWidth
                                            size="small"
                                            id="team"
                                            value={selectedTeam.find((item) => item.Id === team) || ""}
                                            onChange={(_, newValue) => handleTeam(newValue)}
                                            options={selectedTeam}
                                            getOptionLabel={(option) => option.Name || ""}
                                            isOptionEqualToValue={(o, v) => o.Id === v.Id}
                                            renderInput={(params) => (
                                                <TextField {...params} placeholder="All Teams" />
                                            )}
                                            renderOption={(props, option) => (
                                                <li {...props} key={option.Id}>
                                                    {option.Name}
                                                </li>
                                            )}
                                        />
                                    </FormControl>

                                    {tab === 'members' && (
                                        <FormControl size="small" fullWidth sx={{ flex: 1 }} >
                                            <Autocomplete
                                                fullWidth
                                                size="small"
                                                id="executive"
                                                value={selectedExecutive.find((option) => option.Id === executive) || ""}
                                                onChange={(_, newValue) => handlExecutive(newValue)}
                                                options={selectedExecutive}
                                                getOptionLabel={(option) => option.Name || ""}
                                                isOptionEqualToValue={(option, value) => option.Id === value.Id}

                                                renderInput={(params) => (
                                                    <TextField {...params} placeholder="All Executive" />
                                                )}
                                                renderOption={(props, option) => (
                                                    <li {...props} key={option.Id}>
                                                        {option.Name}
                                                    </li>
                                                )}
                                            />
                                        </FormControl>
                                    )}

                                    {/* Show Inactive */}
                                    <Button
                                        variant="outlined"
                                        sx={{
                                            textTransform: "none",
                                            border: "1px solid #D1D5DB",
                                            whiteSpace: "nowrap",
                                            backgroundColor: showInactive ? "#121212" : "transparent",
                                            color: showInactive ? "#FFFFFF" : "#121212",
                                        }}
                                        onClick={handleInactiveToggle}
                                    >
                                        <Icon icon="ic:outline-filter-alt" width="20" height="20" />
                                        {showInactive ? "Hide Inactive" : "Show All Inactive"}

                                    </Button>

                                    {/* Filter */}
                                    <Tooltip title="Filter">
                                        <Button
                                            variant="contained"
                                            size="small"
                                            onClick={onFilterClick}
                                        >
                                            <Icon icon="ic:outline-filter-alt" width="20" height="20" sx={{ mr: '5px' }} />
                                        </Button>
                                    </Tooltip>

                                    {/* Reset */}
                                    <Tooltip title="Reset">
                                        <Button
                                            variant="outlined"
                                            size="small"
                                            onClick={handleReset}
                                        >
                                            <Icon icon="ic:twotone-restart-alt" width="20" height="20" />
                                        </Button>
                                    </Tooltip>

                                </Box>
                            </Box>
                            {/* Scrollable Service Cards Section */}
                            {/*{teamData?.length > 0 ? (*/}
                            {teamRows?.length > 0 ? (

                                <div style={{ height: '65vh', width: '100%', padding: '8px' }}>
                                    <DataGrid rows={teamRows} density={'compact'} columns={teamColumn} getRowId={(row) => teamRows.indexOf(row)} components={{
                                        Toolbar: GridToolbar,
                                    }}
                                        rowsPerPageOptions={[25, 50, 100]}
                                        pageSize={pageSize}
                                        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)} />
                                </div>
                            ) : (
                                <Box
                                    sx={{
                                        height: '68vh',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexDirection: 'column',
                                        textAlign: 'center',
                                    }}
                                >
                                    <Typography sx={{ color: '#E7000B', fontSize: 16, fontWeight: '500' }}>
                                        No Data Found
                                    </Typography>
                                    <Typography variant="body2" sx={{ color: '#928A8A', mt: 0.5 }}>
                                        Apply filters to view results
                                    </Typography>
                                </Box>
                            )}
                        </Card>
                    </Box>

                </Box>
            </ContentStyle >
            {isLoading && (<LoadingProgressBar sx={{ py: 9 }} />)}

        </Page >
    );
}

